'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _coolorsToHex = require('coolors-to-hex');

var _coolorsToHex2 = _interopRequireDefault(_coolorsToHex);

var _composer = require('./composer');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var theme = {};

theme.palette = {
  primary: (0, _coolorsToHex2.default)('https://coolors.co/1976d2-2196f3-71bcf7-97cef9-c2e2fb'),
  secondary: (0, _coolorsToHex2.default)('https://coolors.co/c2185b-e91e63-f06292-f48caf-f8bbd0'),
  danger: (0, _coolorsToHex2.default)('https://coolors.co/d32f2f-f44336-f8877f-f9a7a1-ffcdd2'),
  alert: (0, _coolorsToHex2.default)('https://coolors.co/ffa000-ffc107-ffd761-ffecb3-fff2ce'),
  success: (0, _coolorsToHex2.default)('https://coolors.co/388e3c-4caf50-7cc47f-9fd4a1-c8e6c9'),
  grayscale: ['#212121', '#616161', '#9e9e9e', '#bdbdbd', '#e0e0e0', '#ffffff']
};

theme.reversePalette = (0, _composer.reversePalette)(theme.palette);

theme.fonts = {
  primary: 'Helvetica Neue, Helvetica, Roboto, sans-serif',
  pre: 'Consolas, Liberation Mono, Menlo, Courier, monospace',
  quote: 'Georgia, serif'
};

theme.sizes = {
  maxWidth: '1100px'
};

exports.default = theme;


//////////////////
// WEBPACK FOOTER
// ./~/styled-theme/dist/theme.js
// module id = 637
// module chunks = 97291517795586 114276838955818